// Model
import DepartmentModel from "../model/department.model";

export function mapperToDepartmentModel(departmentDTO) {
    return new DepartmentModel(departmentDTO.id, departmentDTO.name)
}